import React from "react";
import { Heading, Text, Accordion, AccordionItem, AccordionButton, Container, AccordionPanel, AccordionIcon } from "@chakra-ui/react";

import { getParametersByCategory } from "../../utils/helpers";

export const ParameterDefinitions = () => {
  const parametersByCategory = getParametersByCategory();

  return (
    <Container flexDirection={'column'} textAlign={'start'} padding={4} gap={2}>
      <Heading mb={4} fontSize={'2xl'} fontWeight={'bold'}>Parameter Definitions</Heading>
      <Accordion allowMultiple width={'100%'}>
        {parametersByCategory.map((cat) => (
          <AccordionItem key={cat.label} border={'none'} marginBottom={5}>
            <AccordionButton fontSize={'xl'} fontWeight={'bold'} marginBottom={3}>
              {cat.label}
              <AccordionIcon />
            </AccordionButton>
            {cat.parameters.map(([param, meta]) => (
              <AccordionPanel key={param}>
                <Text fontSize={'lg'} fontWeight={'semibold'}>{meta.displayName || param}</Text>
                <Text><strong>Definition:</strong> {meta.definition || 'No definition available.'}</Text>
              </AccordionPanel>
            ))}
          </AccordionItem>
        ))}
      </Accordion>
    </Container>
  )
};
